import { GenIcon } from '../helpers/IconBase.es.js';

const RatingStarSgcFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M14.1892 5.51641L10.222 4.93985L8.44859 1.34454C8.40015 1.2461 8.32046 1.16641 8.22203 1.11797C7.97515 0.9961 7.67515 1.09766 7.55171 1.34454L5.77828 4.93985L1.81109 5.51641C1.70171 5.53204 1.60171 5.5836 1.52515 5.66172C1.43259 5.75686 1.38159 5.88485 1.38334 6.01757C1.3851 6.15029 1.43948 6.27689 1.53453 6.36954L4.40484 9.16797L3.72671 13.1195C3.71081 13.2115 3.72098 13.306 3.75608 13.3924C3.79117 13.4789 3.84978 13.5537 3.92526 13.6086C4.00074 13.6634 4.09007 13.696 4.18312 13.7026C4.27617 13.7092 4.36922 13.6897 4.45171 13.6461L8.00015 11.7805L11.5486 13.6461C11.6455 13.6977 11.758 13.7148 11.8658 13.6961C12.1377 13.6492 12.3205 13.3914 12.2736 13.1195L11.5955 9.16797L14.4658 6.36954C14.5439 6.29297 14.5955 6.19297 14.6111 6.0836C14.6533 5.81016 14.4627 5.55704 14.1892 5.51641Z",
          fill: "#FADB14"
        }
      }
    ]
  })(props);
};

export { RatingStarSgcFilled };
